import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { IconButton, Button, TextField, MenuItem, Select, InputLabel, FormControl, FormHelperText } from "@mui/material";
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import AttachFileIcon from '@mui/icons-material/AttachFile';

const UploadContent = ({ type }) => {
    const history = useHistory();

    const [file, setFile] = useState(null);
    const [fileName, setFileName] = useState('');
    const [category, setCategory] = useState('');
    const [newCategory, setNewCategory] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [error, setError] = useState('');
    const [dragOver, setDragOver] = useState(false);

    const handleFileChange = (event) => {
        const selectedFile = event.target.files[0];
        if (selectedFile) {
            if (selectedFile.size <= 6 * 1024 * 1024 && ['image/jpeg', 'image/png', 'image/jpg', 'application/pdf', 'image/tiff'].includes(selectedFile.type)) {
                setFile(selectedFile);
                setFileName(selectedFile.name);
                setError('');
            } else {
                setError('File must be JPG, JPEG, PNG, TIFF, or PDF and less than 6MB.');
            }
        }
    };

    const handleDrop = (event) => {
        event.preventDefault();
        const droppedFile = event.dataTransfer.files[0];
        if (droppedFile) {
            handleFileChange({ target: { files: [droppedFile] } });
        }
        setDragOver(false);
    };

    const handleDragOver = (event) => {
        event.preventDefault();
        setDragOver(true);
    };

    const handleCategoryChange = (event) => {
        setCategory(event.target.value);
    };

    const handleNewCategoryChange = (event) => {
        setNewCategory(event.target.value);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);

        if (!file || !category) {
            setError('File and category are required.');
            setIsSubmitting(false);
            return;
        }

        try {
            const formData = new FormData();
            formData.append('file', file);
            formData.append('category', category);
            if (newCategory) formData.append('newCategory', newCategory);

            // You can send formData to an API here for submission

            console.log('File uploaded successfully');
            setFile(null);
            setFileName('');
            setCategory('');
            setNewCategory('');
            setIsSubmitting(false);
        } catch (err) {
            console.error('Error uploading file:', err);
            setError('Failed to upload file. Please try again.');
            setIsSubmitting(false);
        }
    };

    return (
        <div className='FeedbackPage'>
            <div className='alerts-section'>
                <div className="alerts-header">
                    <div className="title-container">
                        <IconButton onClick={() => history.push('/Home')}>
                            <ArrowBackIosNewIcon
                                className="z-0"
                                style={{ color: 'rgb(14, 81, 46)' }}
                            />
                        </IconButton>
                        <h2 className='input-header'>{type}</h2>
                        <div className="placeholder" style={{ width: '40px', backgroundColor: 'transparent' }}></div>
                    </div>
                </div>

                <div style={{ padding: '2em' }}>
                    <div
                        style={{
                            width: '100%',
                            padding: '20px',
                            border: '2px dashed #3498db',
                            textAlign: 'center',
                            cursor: 'pointer',
                            borderRadius: '8px',
                            transition: 'background-color 0.3s ease',
                            backgroundColor: dragOver ? '#f0f8ff' : 'transparent',
                        }}
                        onDrop={handleDrop}
                        onDragOver={handleDragOver}
                        onDragLeave={() => setDragOver(false)}
                    >
                        <input
                            type="file"
                            accept=".jpg,.jpeg,.png,.pdf,.tiff"
                            style={{ display: 'none' }}
                            onChange={handleFileChange}
                            id="file-upload-input"
                        />
                        <label htmlFor="file-upload-input" style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                            <AttachFileIcon style={{ fontSize: '40px', color: '#3498db' }} />
                            <p style={{ marginTop: '10px', fontSize: '16px', color: '#3498db' }}>
                                {file ? 'File Attached' : 'Drag your file here or click to select a file'}
                            </p>
                        </label>
                    </div>

                    {error && <FormHelperText error>{error}</FormHelperText>}
                    {fileName && (
                        <div style={{ marginTop: '10px', fontSize: '14px', color: '#333' }}>
                            <strong>File Selected:</strong> {fileName}
                        </div>
                    )}
                </div>

                <div style={{padding: '2em', paddingTop: '1em' }}> 
                    <FormControl fullWidth style={{ marginBottom: '20px' }}>
                        <InputLabel id="category-label">Select a Category</InputLabel>
                        <Select
                            labelId="category-label"
                            value={category}
                            onChange={handleCategoryChange}
                            fullWidth
                        >
                            <MenuItem value="category1">Category 1</MenuItem>
                            <MenuItem value="category2">Category 2</MenuItem>
                            <MenuItem value="category3">Category 3</MenuItem>
                        </Select>
                    </FormControl>

                    <div style={{ marginBottom: '20px' }}>
                        <h2 style={{ fontSize: '16px', textAlign: 'left' }}>Or add a new category</h2>
                        <TextField
                            label="New Category"
                            value={newCategory}
                            onChange={handleNewCategoryChange}
                            fullWidth
                            variant="outlined"
                        />
                    </div>

                    <div style={{ marginTop: '20px' }}> 
                        <button className='alert-info-button' 
                            onClick={handleSubmit}
                            style={{padding: '0.5em 1.25em', fontSize: '16px'}}>
                            {isSubmitting ? 'Uploading...' : 'Upload File'}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UploadContent;
